import { isEmpty, isNull } from 'lodash';
export function getDisplayNames(builders) {
    return !isEmpty(builders) && builders.map(function(builder) {
        return builder.displayName = isNull(builder.integrationId) ? "".concat(builder.name) : "".concat(builder.name, " - ").concat(builder.integrationId);
    });
}
